module.exports = __webpack_public_path__ + "static/media/page1_pic7.f94c6b02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/page1_pic7.jpg
// module id = 541
// module chunks = 0